import 'css-chunksrc/client/scenes/milestone/milestoneCompletion/styles.scss';export default {
  "milestoneCompletion": "_milestoneCompletion_1qwz5_1",
  "icon": "_icon_1qwz5_8",
  "completed": "_completed_1qwz5_16",
  "input": "_input_1qwz5_20",
  "listRoot": "_listRoot_1qwz5_36",
  "list": "_list_1qwz5_36",
  "item": "_item_1qwz5_56",
  "name": "_name_1qwz5_61",
  "doneName": "_doneName_1qwz5_67",
  "open": "_open_1qwz5_71",
  "done": "_done_1qwz5_67",
  "readOnly": "_readOnly_1qwz5_89"
};